// tpj-mega-menu.js
// 1) Regroups mega-menu sub-buckets into 4 stacked column wrappers so the
//    panel fits on one screen.
//    The first bucket (Animals) always takes column 1 and is shown in 3 short
//    sub-columns via CSS (tpj-nav.css "NAV REFRESH"). Every other bucket is
//    placed in whichever column is currently shortest (biggest buckets first),
//    so adding or removing a bucket in Shopify admin never needs a code change.
//    Rewritten 2026-09-26 (card #738): the old hard-coded maps only knew 5 or 6
//    buckets, and the 7th bucket ("Vehicles & Rescue", 2026-09-05) left the
//    Shop by Theme panel ungrouped and taller than the screen.
// 2) Header hides while scrolling down and slides back when scrolling up.

(function () {
  var COLUMNS = 4;

  function bucketRows(item) {
    var list = item.querySelector('.menu__grandchild > ul.mega-menu__grandchild');
    var n = list ? list.children.length : 0;
    return n + 2; // heading pill + gap count as ~2 rows
  }

  var DESKTOP = window.matchMedia('(min-width: 1024px)');

  function tpjGroupMegaMenu() {
    // desktop only: the phone drawer keeps the menu's own order
    if (!DESKTOP.matches) return;
    var submenus = document.querySelectorAll('.menu__item-megamenu .mega-menu__submenu:not([data-tpj-grouped])');
    submenus.forEach(function (submenu) {
      var items = Array.prototype.filter.call(submenu.children, function (el) {
        return el.classList && el.classList.contains('menu__item');
      });
      if (items.length < 2) return;

      // column 1 = first bucket, shown in 3 sub-columns.
      // Lead mode (W1026, 2026-10-25): when the first bucket is a short list of
      // quick links (4 or fewer, e.g. Gallery Sets > Shop Sets), it gets its own
      // narrow column at the far left and the second bucket (Animals) takes the
      // wide 3-sub-column slot next to it. Set by data-tpj-lead; CSS in tpj-nav.css.
      var firstList = items[0].querySelector('.menu__grandchild > ul.mega-menu__grandchild');
      var firstCount = firstList ? firstList.children.length : 0;
      var lead = firstCount > 0 && firstCount <= 4 && items.length >= 3;
      var wide = lead ? 1 : 0;
      var cols = [];
      for (var c = 0; c < COLUMNS; c++) cols.push({ rows: 0, idxs: [] });
      if (lead) {
        var wideList = items[1].querySelector('.menu__grandchild > ul.mega-menu__grandchild');
        cols[0].rows = bucketRows(items[0]);
        cols[0].idxs.push(0);
        cols[1].rows = Math.ceil((wideList ? wideList.children.length : 0) / 3) + 2;
        cols[1].idxs.push(1);
      } else {
        cols[0].rows = Math.ceil(firstCount / 3) + 2;
        cols[0].idxs.push(0);
      }

      // biggest remaining buckets first, each into the shortest column
      // (the wide column only takes more when every other column is taller)
      var rest = items.slice(wide + 1).map(function (el, i) { return { i: i + wide + 1, rows: bucketRows(el) }; });
      rest.sort(function (a, b) { return b.rows - a.rows || a.i - b.i; });
      rest.forEach(function (b) {
        var target = cols[wide];
        for (var k = 0; k < COLUMNS; k++) {
          if (k === wide) continue;
          if (cols[k].rows < target.rows || (target === cols[wide] && cols[k].rows === target.rows)) target = cols[k];
        }
        target.idxs.push(b.i);
        target.rows += b.rows;
      });
      if (lead) submenu.setAttribute('data-tpj-lead', 'true');

      cols.forEach(function (col) {
        if (!col.idxs.length) return;
        col.idxs.sort(function (a, b) { return a - b; }); // keep menu order inside a column
        var wrapper = document.createElement('li');
        wrapper.className = 'megamenu-column';
        col.idxs.forEach(function (i) { wrapper.appendChild(items[i]); });
        submenu.appendChild(wrapper);
      });

      // Single Prints and Gallery Sets panels (5+ buckets) get a full-width "Shop all" bar at the TOP (Niv, 2026-11-03)
      if (items.length >= 5) {
        var bar = document.createElement('li');
        // spans the full grid row; a plain item would shift every bucket one cell right
        bar.style.cssText = 'list-style:none;grid-column:1/-1;width:100%;';
        bar.innerHTML = '<a class="tpj-megamenu-bottombar tpj-megamenu-bottombar--top" href="/collections/all">' +
          "Can't decide? <strong>Shop all wall art</strong>" +
          ' <span class="tpj-megamenu-bottombar__arrow">&rarr;</span></a>';
        submenu.insertBefore(bar, submenu.firstChild);
      }
      submenu.setAttribute('data-tpj-grouped', 'true');
    });
  }

  function tpjSmartHeader() {
    var wrap = document.querySelector('.header-wrapper');
    if (!wrap || wrap.classList.contains('tpj-hdr')) return;
    wrap.classList.add('tpj-hdr');
    var lastY = window.pageYOffset;
    var ticking = false;

    function somethingOpen() {
      // keep the header in view while a menu, the search panel or the drawer is open
      // (level-2 <details> are always [open] in Blum's markup, so check level 1 only)
      return !!wrap.querySelector('details[data-level="1"][open]') ||
        document.body.classList.contains('o-hidden') ||
        document.documentElement.classList.contains('o-hidden');
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset;
      var hideAfter = wrap.offsetHeight + 120;
      wrap.style.setProperty('--tpj-hdr-h', (wrap.offsetHeight + 40) + 'px'); // + room for the shadow
      if (y <= hideAfter || somethingOpen()) {
        wrap.classList.remove('tpj-hdr--hidden');
      } else if (y > lastY + 6) {
        wrap.classList.add('tpj-hdr--hidden');
      } else if (y < lastY - 6) {
        wrap.classList.remove('tpj-hdr--hidden');
      }
      if (Math.abs(y - lastY) > 6) lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    // keyboard users tabbing into the header always see it
    wrap.addEventListener('focusin', function () { wrap.classList.remove('tpj-hdr--hidden'); });
  }

  function init() { tpjGroupMegaMenu(); tpjSmartHeader(); }

  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', tpjGroupMegaMenu);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.menu__item-megamenu')) {
      init();
    }
  });
})();
